import React from 'react'

type Props = JSX.IntrinsicElements['p'] & {
  className?: never
}
export const MessageForAction: React.VFC<Props> = (props) => {
  return <p {...props} className="text-em_01">{props.children}</p>
}
